/* ZANCADACLUB — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    var fmt = (window.zcMoneyFormat || '{{amount_with_comma_separator}} €');
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---------- Revelado al hacer scroll (un único observador) ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.zc-reveal:not(.zc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zc-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('zc-visible');
            revealObserver.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  var parallaxEls = [];
  var ticking = false;
  function initParallax(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-zc-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (!parallaxEls.length) return;
    if (!initParallax.bound) {
      initParallax.bound = true;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          parallaxEls.forEach(function (el) {
            if (!document.body.contains(el)) return;
            var k = parseFloat(el.getAttribute('data-zc-parallax')) || 0;
            var rect = el.parentElement.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > window.innerHeight) return;
            el.style.transform = 'translate3d(0,' + (-rect.top * k / 100) + 'px,0)';
          });
          ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-zc-count]');
    if (!els.length) return;
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-zc-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      if (reduce) { el.textContent = target.toFixed(dec).replace('.', ','); return; }
      var dur = 1600, t0 = null;
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = (target * eased).toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Comparador antes/después ---------- */
  function initComparador(root) {
    (root || document).querySelectorAll('.zc-comp__wrap').forEach(function (wrap) {
      var range = wrap.querySelector('.zc-comp__range');
      if (!range || range.dataset.zcBound) return;
      range.dataset.zcBound = '1';
      var set = function (v) { wrap.style.setProperty('--zc-pos', v + '%'); };
      set(range.value);
      range.addEventListener('input', function () { set(range.value); });
    });
  }

  /* ---------- Selector de colores (sección destacada) ---------- */
  function initColores(root) {
    (root || document).querySelectorAll('[data-zc-colores]').forEach(function (box) {
      if (box.dataset.zcBound) return;
      box.dataset.zcBound = '1';
      var imgs = box.querySelectorAll('.zc-colores__stage img');
      var sws = box.querySelectorAll('.zc-swatch');
      var name = box.querySelector('[data-zc-color-name]');
      var glow = box.querySelector('.zc-colores__glow');
      var cta = box.querySelector('[data-zc-color-link]');
      var activate = function (i) {
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
        sws.forEach(function (s, j) {
          s.classList.toggle('is-active', i === j);
          s.setAttribute('aria-pressed', i === j ? 'true' : 'false');
        });
        var sw = sws[i];
        if (!sw) return;
        if (name) name.textContent = sw.getAttribute('data-name');
        if (glow) glow.style.setProperty('--zc-glow', sw.getAttribute('data-color'));
        if (cta && sw.getAttribute('data-url')) cta.setAttribute('href', sw.getAttribute('data-url'));
      };
      sws.forEach(function (s, i) {
        s.addEventListener('click', function () { activate(i); });
        s.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) activate(i); });
      });
      activate(0);
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-zc-pdp]').forEach(function (pdp) {
      if (pdp.dataset.zcBound) return;
      pdp.dataset.zcBound = '1';

      var dataEl = pdp.querySelector('[data-zc-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

      /* Galería */
      var main = pdp.querySelector('.zc-pdp__main img');
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('.zc-pdp__thumb'));
      var counter = pdp.querySelector('.zc-pdp__counter');
      var current = 0;
      var show = function (i) {
        if (!main || !thumbs.length) return;
        i = (i + thumbs.length) % thumbs.length;
        current = i;
        var t = thumbs[i];
        thumbs.forEach(function (th, j) { th.classList.toggle('is-active', j === i); });
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        if (main.getAttribute('src') === src) return;
        main.classList.add('is-fading');
        setTimeout(function () {
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          main.setAttribute('alt', t.getAttribute('data-alt') || '');
          main.classList.remove('is-fading');
        }, 180);
        if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
        t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = pdp.querySelector('.zc-pdp__nav--prev');
      var next = pdp.querySelector('.zc-pdp__nav--next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var mainWrap = pdp.querySelector('.zc-pdp__main');
      if (mainWrap) {
        var sx = null;
        mainWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }

      /* Variantes */
      var form = pdp.querySelector('form[data-zc-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = pdp.querySelector('.zc-pdp__add');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var priceNow = pdp.querySelector('.zc-pdp__price-now');
      var priceOld = pdp.querySelector('.zc-pdp__price-old');
      var save = pdp.querySelector('.zc-pdp__save');
      var stock = pdp.querySelector('.zc-pdp__stock');
      var stockTxt = stock ? stock.querySelector('span') : null;
      var stickyPrice = document.querySelector('.zc-sticky-buy__txt span');
      var stickyBtn = document.querySelector('.zc-sticky-buy .zc-btn');
      var labels = pdp.dataset;

      var selected = function () {
        var vals = [];
        pdp.querySelectorAll('.zc-pdp__option').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var lg = fs.querySelector('legend b');
          if (lg && c) lg.textContent = c.value;
        });
        return vals;
      };
      var update = function (fromUser) {
        if (!variants.length) return;
        var vals = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return vals[i] === null || o === vals[i]; });
        });
        // Disponibilidad por valor
        pdp.querySelectorAll('.zc-pdp__option').forEach(function (fs, idx) {
          fs.querySelectorAll('.zc-pdp__value').forEach(function (wrap) {
            var input = wrap.querySelector('input');
            var ok = variants.some(function (x) {
              return x.available && x.options.every(function (o, i) { return i === idx ? o === input.value : (vals[i] === null || o === vals[i]); });
            });
            wrap.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = labels.unavailable;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceOld) { priceOld.textContent = onSale ? money(v.compare_at_price) : ''; priceOld.hidden = !onSale; }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = labels.saveLabel + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (stickyBtn) stickyBtn.toggleAttribute('disabled', !v.available);
        if (addLabel) addLabel.textContent = v.available ? labels.addLabel : labels.soldout;
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          if (stockTxt) stockTxt.textContent = v.available ? labels.instock : labels.soldout;
        }
        if (fromUser && v.featured_media_id) {
          var ti = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') === String(v.featured_media_id); });
          if (ti > -1) show(ti);
        }
        if (fromUser && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      };
      pdp.querySelectorAll('.zc-pdp__option input').forEach(function (inp) {
        inp.addEventListener('change', function () { update(true); });
      });
      update(false);

      /* Cantidad */
      var qty = pdp.querySelector('.zc-qty input');
      pdp.querySelectorAll('.zc-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
          qty.value = Math.max(1, n);
        });
      });

      /* Añadir al carrito (abre el cajón del carrito si existe) */
      var msg = pdp.querySelector('.zc-pdp__msg');
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!window.fetch || !window.FormData) return;
          e.preventDefault();
          if (addBtn) addBtn.classList.add('is-loading');
          if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
          var fd = new FormData(form);
          if (drawer) {
            fd.append('sections', 'cart-drawer,cart-icon-bubble');
            fd.append('sections_url', window.location.pathname);
          }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (msg) { msg.textContent = res.description || res.message || labels.error; msg.classList.add('is-error'); }
                return;
              }
              if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
                drawer.classList.remove('is-empty');
                drawer.renderContents(res);
              } else {
                window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              }
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
        });
      }

      /* Botón de oferta: añade varias unidades de golpe */
      var promoBtn = pdp.querySelector('[data-zc-promo-qty]');
      if (promoBtn && form) {
        promoBtn.addEventListener('click', function () {
          var n = parseInt(promoBtn.getAttribute('data-zc-promo-qty'), 10) || 2;
          var q = form.querySelector('input[name="quantity"]');
          if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
          q.value = n;
          if (form.requestSubmit) form.requestSubmit(); else if (addBtn) addBtn.click();
        });
      }

      /* Barra de compra fija en móvil */
      var sticky = document.querySelector('.zc-sticky-buy');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }).observe(addBtn);
        var sb = sticky.querySelector('.zc-btn');
        if (sb) sb.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
        });
      }
    });
  }

  function initAll(root) {
    initReveal(root);
    initParallax(root);
    initCounters(root);
    initComparador(root);
    initColores(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
